import CardWrapper from '../wrapper/card';
import { ConnectDomainParams } from '../../params/redux/domain';
import { connectDomainSchema } from '../../schema/domain_schema';
import CustomDropdown from '../reusable/dropdown';
import CustomInput from '../reusable/input';
import { domainSellerList } from '../../helper/lists';
import LabelWrapper from '../wrapper/label';
import { toast } from 'react-toastify';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, Typography } from '@mui/material';
import { Form, Formik } from 'formik';
import { settingConnectingDomain, settingIndexForConnectingDomain, settingIsConnectingFlagDomain } from '../../redux/slices/domain';
import { useDispatch, useSelector } from 'react-redux';

const DomainDetailsComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { flags, connectDomain } = useSelector((state: RootState) => state.domain);
    const initialValues = {
        domain: connectDomain.domain_name || '',
        seller: connectDomain.domain_seller || ''
    };
    const nextStepSaveHandler = (values: {
        domain: string;
        seller: string;
    }) => {
        const domainRegex = /^(?:www\.)?[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+$/u;

        if (!domainRegex.test(values.domain)) {
            toast.error('Please enter a valid domain (e.g., example.com or www.example.com)', {
            position: 'top-left',
            autoClose: 3000,
            theme: 'dark'
            });
            return;
        }

        const data: ConnectDomainParams = {
            ...connectDomain,
            domain_name: values.domain,
            domain_seller: values.seller
        };
        dispatch(settingConnectingDomain(data));
        dispatch(settingIndexForConnectingDomain(flags.selectedIndex + 1));
    };

    const cancelDomainHandler = () => {
        dispatch(settingIsConnectingFlagDomain(false));
    };

    return <Box>
        <Formik
            initialValues={initialValues}
            validationSchema={connectDomainSchema}
            onSubmit={nextStepSaveHandler}
        >
            {({ values, handleChange, handleBlur, errors, touched, setFieldValue }) => (
                <Form>
                    <CardWrapper>
                        <Typography variant="subtitle1" fontWeight="bold" color="textSecondary">Domain details</Typography>
                        <Typography variant="subtitle2" color="textDisabled">If you  already own a domain from another company,you can connect it to gonzy here.</Typography>
                        <Box display="flex" gap={2} mt={2}>
                            <CustomInput
                                label="Enter the domain you own"
                                placeholder="Existingdomain.com"
                                fullWidth
                                name="domain"
                                value={values.domain}
                                onChange={handleChange('domain')}
                                onBlur={handleBlur('domain')}
                                error={touched.domain && errors.domain}
                                mandatoryFields={true}
                            />
                            <Box width="100%">
                                <LabelWrapper label="Where did you buy this domain" isMandatory={true} />
                                <CustomDropdown
                                    options={domainSellerList.map((item) => ({
                                        label: item,
                                        value: item
                                    }))}
                                    placeholder="Hosting platform"
                                    value={values.seller}
                                    onChange={(e) => setFieldValue('seller', e.target.value)}
                                    error={Boolean(touched.seller && errors.seller)}
                                />
                            </Box>
                        </Box>
                    </CardWrapper>
                    <Box display="flex" gap={2} justifyContent="end" mt={4}>
                        <Button variant="outlined" size="large" color="secondary" onClick={cancelDomainHandler}>Cancel</Button>
                        <Button type="submit" variant="contained" size="large">Continue</Button>
                    </Box>
                </Form>
            )}</Formik>
    </Box>;
};

export default DomainDetailsComponent;